import { SYSTEM_MODES } from '@silverfort-nodelibs/common/utils/system-mode-config';
import { FEATURE_FLAGS_NAMES } from '@silverfort-nodelibs/common/utils/consts';

import useFeature from '../featureFlags/useFeature';
import {
    PricingModulesStatus,
    SYSTEM_MODE,
    usePricingModulesState
} from '../../../../context/contexts/PricingModuleContext';
import { useMemo } from 'react';
import { CATEGORIES } from '../../common/categories';
import { HIDDEN_CATEGORIES_CONFIG } from './hiddenCategoriesConfigs';
import { isAnyEnablingModulesActive } from './utils';

const isCategoryEnabled = (
    categoryId: string,
    pricingModulesState: PricingModulesStatus,
    mode: SYSTEM_MODE
): boolean => {
    if (!(categoryId in HIDDEN_CATEGORIES_CONFIG)) return true;
    const { enabledByModules, hiddenBySystemModes } = HIDDEN_CATEGORIES_CONFIG[categoryId];
    if (hiddenBySystemModes?.includes(mode)) return false;
    if (enabledByModules === undefined) return true;
    return isAnyEnablingModulesActive(enabledByModules, pricingModulesState);
};

const buildCategoriesToDisplay = (
    categoryIds: string[],
    PricingModulesStatus: PricingModulesStatus,
    mode: SYSTEM_MODE
) => {
    return categoryIds.filter((categoryId) => isCategoryEnabled(categoryId, PricingModulesStatus, mode));
};

export const useGetVisibleCategoryIds = (categoryIds?: string[]) => {
    const systemMode: SYSTEM_MODE | undefined = useFeature(FEATURE_FLAGS_NAMES.SystemMode);
    const { pricingModulesState } = usePricingModulesState();
    const categoriesToDisplay = useMemo(() => {
        if (pricingModulesState) {
            return buildCategoriesToDisplay(
                categoryIds || Object.values(CATEGORIES).map((category) => category.ID),
                pricingModulesState,
                systemMode ?? SYSTEM_MODES.ON_PREM
            );
        }
        return [];
    }, [categoryIds, pricingModulesState, systemMode]);
    return categoriesToDisplay;
};
